import { Button as ButtonAntD, Modal as ModalAntD } from 'antd';
import { Link as LinkRouter } from 'react-router-dom';
import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';

const Modal: any = ModalAntD;

export const Div = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  @media (min-width: 480px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const Link = styled(LinkRouter)`
  color: ${({ theme }) => theme.primary};

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Title = styled.h1`
  display: flex;
  margin: 0;
  font-size: 21px;
  font-weight: 600;
  font-family: 'Roboto';
  color: #000;
  align-items: center;
  margin-bottom: 24px;

  @media (min-width: 480px) {
    margin-bottom: 0%;
  }

  @media (min-width: 1025px) {
    padding-left: 4px;
  }

  @media (min-width: 1921px) {
    margin-bottom: 0;
  }

  svg {
    align-items: center;
    display: flex;
    margin-right: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-direction: column;
  align-items: center;
  margin-left: 16px;
  margin-right: 16px;

  @media (min-width: 480px) {
    flex-direction: row;
    align-items: flex-start;
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  padding: 96px 24px;
  margin-left: 16px;
  margin-right: 16px;

  .ant-empty-description {
    font-size: 18px;
  }

  @media (min-width: 480px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Item = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  padding: 24px;
  display: flex;
  gap: 16px;
  cursor: pointer;

  @media (min-width: 640px) {
    height: 128px;
  }
`;

export const Items = styled.div`
  display: flex;
  gap: 16px;
  margin-left: 16px;
  margin-right: 16px;
  flex-direction: column;

  ${Item} {
    width: 100%;
  }

  @media (min-width: 480px) {
    margin-left: 0;
    margin-right: 0;
  }

  @media (min-width: 640px) {
    flex-direction: row;
    flex-wrap: wrap;

    ${Item} {
      width: calc(50% - 8px);
      max-width: calc(50% - 8px);
    }
  }

  @media (min-width: 980px) {
    ${Item} {
      width: calc(33.33% - 11px);
      max-width: calc(33.33% - 11px);
    }
  }
`;

export const Icon = styled.div`
  background-color: ${({ theme }) => theme.hoveredDiv};
  width: 80px;
  height: 80px;
  border-radius: 3px;
  align-items: center;
  display: flex;
  justify-content: center;

  svg {
    color: ${({ theme }) => theme.primary};
    font-size: 30px;
  }
`;

export const BlankLoading = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  column-gap: 16px;

  div {
    height: 128px;
    width: 100%;
  }

  @media (min-width: 480px) {
    margin-left: 0;
    margin-right: 0;
  }

  @media (min-width: 640px) {
    flex-direction: row;
    flex-wrap: wrap;

    div {
      width: calc(50% - 8px);
    }
  }

  @media (min-width: 980px) {
    div {
      width: calc(33.33% - 11px);
    }
  }
`;

export const Button = styled(ButtonAntD)`
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  width: 100%;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const NewButton = styled(Button)`
  @media (min-width: 480px) {
    width: auto;
  }
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const ItemInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: nowrap;
  width: calc(100% - 80px - 32px);
`;

export const ItemTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 8px;
  height: 48px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 640px) {
    -webkit-line-clamp: 1;
  }

  @media (min-width: 980px) {
    -webkit-line-clamp: 2;
  }
`;

export const ItemSubTitle = styled.div`
  color: #7f7f7f;
  font-weight: 300;
  font-size: 15px;
`;

export const WrapperContinueButton = styled.div`
  margin-bottom: 0;
  margin-top: 24px;
`;

export const ErrorModal = styled(Modal)`
  min-width: calc(320px - 16px);

  .ant-modal-body {
    padding: 16px;

    @media (min-width: 480px) {
      padding: 24px;
    }
  }

  .ant-result {
    padding: 0;
  }

  .ant-result-extra {
    display: flex;
    gap: 16px;
    flex-direction: column;

    > * {
      margin-right: 0;
    }

    @media (min-width: 480px) {
      gap: 24px;
      flex-direction: row;
    }
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  color: black;
  cursor: pointer;
  z-index: 2;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  .anticon {
    font-size: 24px;
  }

  &:hover {
    color: red;
  }
`;

/** Ocupa a mesma posição da DeleteButton, que não renderiza em somente leitura */
export const ReadOnlyTag = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  background-color: ${COLORS.transparentDark};
  border: 1px solid ${COLORS.stone};
  border-radius: 3px;
  color: ${COLORS.lightDarkText};
  font-size: 12px;
  line-height: 1;
  padding: 5px 8px;
  white-space: nowrap;
`;
